import Client, { ClientOption } from "../client";

export default {
  // returns list of all the Car route
  storeQuizPerformance: (params: any, options?: ClientOption) =>
    Client("POST", "quiz-performance/store", params, options),

  getLeaderboardPerformance: (startDate: string, endDate: string, page: number = 1, options?: ClientOption) =>
    Client("GET", `quiz-performance/leaderboard?start_date=${startDate}&end_date=${endDate}&page=${page}`, undefined, options),
};
